module.exports = __webpack_public_path__ + "static/netflix4-bg-0822db7c97d24d27c336431febccf2b7.png";